// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 16 16" {...rest} unit={unit}>
		<g stroke="none" strokeWidth="1" fillRule="evenodd">
			<path d="M11.6625173,10.6814404 L10.3347165,9.35180055 C12.1051176,
				7.04709141 11.9280775,3.85595568 9.80359613,1.72853186 C7.59059474,
				-0.576177285 3.87275242,-0.576177285 1.65975104,1.72853186 C-0.553250346,
				4.033241 -0.553250346,7.66759003 1.65975104,9.88365651 C3.69571231,
				11.9224377 6.97095436,12.099723 9.2724758,10.4155125 L10.6002766,
				11.7451524 L15.0262794,16 C15.2033195,15.9113573 15.9114799,15.2022161 16,
				15.0249307 L11.6625173,10.6814404 L11.6625173,10.6814404 Z M2.54495159,
				9.08587258 C0.774550484,7.31301939 0.774550484,4.38781163 2.54495159,
				2.61495845 C4.3153527,0.842105263 7.23651452,0.842105263 9.00691563,
				2.61495845 C10.7773167,4.38781163 10.7773167,7.31301939 9.00691563,
				9.08587258 C7.14799447,10.8587258 4.3153527,10.8587258 2.54495159,
				9.08587258 L2.54495159,9.08587258 Z" />
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/Search.js